import React, { useState } from "react";
import "../../../components/FilterDrawer/filterDrawer.scss"; 
import {
  Box,
  Button,
  Drawer,
  Grid,
  Typography,
} from "@mui/material";

import { cross_default_icon } from "../../../constants/icons";
import { font_15 } from "../../../utils/utils";
import IconButtons from "../../../components/IconButtons/IconButtons";
import Loader from "../../../components/Loader/Loader";
import SimpleAutoComplete from "../../../components/SimpleAutoComplete/SimpleAutoComplete";

const FormResponseFilterDrawer = ({
  open,
  onClose,
  handleFilterChange,
  handleFilterRemove,
  handleFilterSubmit,
  filterValue,
  statusOptions = [],
}) => {
  const [loader, setLoader] = useState(false);

  const handleFilter = async () => {
    setLoader(true);
    await handleFilterSubmit();
    setLoader(false);
  };

  if (loader) {
    return <Loader />;
  }

  return (
    <Drawer
      className="filter-drawer-container"
      anchor="right"
      open={open}
      onClose={onClose}
    >
      <Grid container className="filter-main-container">
        <Grid item md={12} pt={2} className="drawer-input-container">
          <Box className="filter-head">
            <Typography variant="font_20" className="filter-title">
              Filters
            </Typography>
            <IconButtons
              handleClick={onClose}
              height={font_15}
              width={font_15}
              image={cross_default_icon}
              tooltip="Close Filter"
            />
          </Box>

          <Box className="filter-padding textfield-box">
            <SimpleAutoComplete
              label="Status"
              placeholder="Select Status"
              options={statusOptions}
              value={filterValue?.status}
              onChange={(event, newValue) =>
                handleFilterChange("status", newValue)
              }
              getOptionLabel={(option) => option?.name || ""}
              renderOption={(props, option) => (
                <li
                  {...props}
                  key={props.id}
                  className={
                    option?.id === filterValue?.status?.id
                      ? "multi-tag-edit-list-selected"
                      : "multi-tag-style"
                  }
                >
                  <Box>{option?.name}</Box>
                </li>
              )}
            />
          </Box>
        </Grid>

        <Grid item md={12} className="filter-padding filter-btn-container">
          <Button
            onClick={handleFilter}
            variant="contained"
            color="secondary"
            className="block-button filter-btn margin-right-1"
          >
            <Typography variant="outlineBtnLabel">
              Apply Filters
            </Typography>
          </Button>
          <Button
            onClick={handleFilterRemove}
            variant="outlined"
            color="secondary"
            className="block-button filter-btn"
          >
            <Typography variant="outlineBtnLabel">
              Reset
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
};

export default FormResponseFilterDrawer;